<template>
  <div class="restriktionen-year">
    <RestriktionenMiniMonth
      v-for="monthDate in monthDates"
      :key="monthDate.valueOf()"
      :date="monthDate"
      :restriktionen="restriktionen"
      @month-click="$emit('month-click', $event)"
    />
  </div>
</template>

<script>
import moment from 'moment-timezone';
import RestriktionenMiniMonth from './restriktionen-mini-month.vue';

export default {
  name: 'RestriktionenYearViewComponent',
  components: {
    RestriktionenMiniMonth,
  },
  props: {
    year: {
      type: Number,
      required: true,
    },
    restriktionen: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    monthDates() {
      return Array.from({ length: 12 }, (_, monthIndex) =>
        moment().year(this.year).month(monthIndex).startOf('month')
      );
    },
  },
};
</script>

<style scoped>
.restriktionen-year {
  display: grid;
  flex: 1 1 auto;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(3, 1fr);
  gap: 32px;
  min-height: 0;
}
</style>
